import { IDashboardLayout } from 'components/Visualization/CDashboard/types';

import { CloudEventsSummaryState } from '../../../types';

import { getCloudEventsSummaryWidgets } from './widget';

export const getCloudEventsSummaryConfig = (
  summary: CloudEventsSummaryState,
  summaryPeriod?: string,
): IDashboardLayout => ({
  id: 'cloud_events_summary',
  title: 'Cloud Events Summary',
  widgets: [
    {
      type: 'line-chart',
      i: 'apiCalls',
      x: 0,
      y: 0,
      w: 3,
      h: 8,
      isResizable: false,
      static: true,
    },
    {
      type: 'bar-chart',
      i: 'dataAccessed',
      x: 3,
      y: 0,
      w: 3,
      h: 8,
      isResizable: false,
      static: true,
    },
    {
      type: 'stacked-bar-chart',
      i: 'apiCallsByActionType',
      x: 6,
      y: 0,
      w: 3,
      h: 8,
      isResizable: false,
      static: true,
    },
    {
      type: 'line-chart',
      i: 'insights',
      x: 9,
      y: 0,
      w: 3,
      h: 8,
      isResizable: false,
      static: true,
    },
  ],
  available: getCloudEventsSummaryWidgets(summary, false, summaryPeriod),
});

export const getHourlyAccessSummaryConfig = (
  summary: CloudEventsSummaryState,
): IDashboardLayout => {
  const config = getCloudEventsSummaryConfig(summary);

  return {
    ...config,
    id: 'hourly_access_summary',
    title: 'Hourly Access Summary',
    available: getCloudEventsSummaryWidgets(summary, true),
    widgets: config.widgets.map((widget, index) => ({
      ...widget,
      x: 0,
      y: index * 8,
      w: 12,
    })),
  };
};
